function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { drawerAnatomy as parts } from "@chakra-ui/anatomy";
export { Drawer, DrawerBody, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton } from "@chakra-ui/react";
/**
 * Since the `maxWidth` prop references theme.sizes internally,
 * we can leverage that to size our modals.
 */ function getSize(value) {
    if (value === 'full') {
        return {
            dialog: {
                maxW: '100vw',
                h: '100vh'
            }
        };
    }
    return {
        dialog: {
            maxW: value
        }
    };
}
const baseStyleOverlay = {
    bg: 'blackAlpha.600',
    zIndex: 'overlay'
};
const baseStyleDialogContainer = (props)=>{
    const { containerHeight } = props;
    return {
        display: 'flex',
        zIndex: 'modal',
        justifyContent: 'center',
        height: containerHeight || '100vh'
    };
};
const baseStyleDialog = (props)=>{
    const { isFullHeight, height, maxHeight } = props;
    return _object_spread_props(_object_spread({}, isFullHeight && {
        height: '100vh'
    }), {
        zIndex: 'modal',
        maxH: maxHeight || '100vh',
        height,
        background: 'background.neutral.secondary.default',
        color: 'inherit',
        boxShadow: 'dark-lg',
        _dark: {
            boxShadow: 'dark-lg'
        }
    });
};
const baseStyleHeader = {
    px: 6,
    py: 4,
    fontSize: 'xl',
    fontWeight: 'semibold'
};
const baseStyleCloseButton = {
    position: 'absolute',
    top: 3,
    insetEnd: 3
};
const baseStyleBody = {
    px: 6,
    py: 2,
    flex: 1,
    overflow: 'auto'
};
const baseStyleFooter = {
    px: 6,
    py: 4
};
const baseStyle = (props)=>({
        overlay: baseStyleOverlay,
        dialogContainer: baseStyleDialogContainer(props),
        dialog: baseStyleDialog(props),
        header: baseStyleHeader,
        closeButton: baseStyleCloseButton,
        body: baseStyleBody,
        footer: baseStyleFooter
    });
const sizes = {
    xs: getSize('xs'),
    sm: getSize('md'),
    md: getSize('lg'),
    lg: getSize('2xl'),
    xl: getSize('4xl'),
    full: getSize('full')
};
const defaultProps = {
    size: 'xs'
};
export const ThemedDrawer = {
    parts: parts.keys,
    baseStyle,
    sizes,
    defaultProps
};

//# sourceMappingURL=Drawer.js.map